// /* generated using openapi-typescript-codegen -- do no edit */
// /* istanbul ignore file */
// /* tslint:disable */
// /* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { PaginatedResponseDTO } from '../models/PaginatedResponseDTO';
import type { PaymentDTO } from '../models/PaymentDTO';
import { OpenAPI } from '../core/OpenAPI';

import { request as __request } from '../core/request';
import { Paydata } from '../models/PointDTO';
import { ResponseDTO } from '../models/ResponseDTO';

export interface createInvoiceProps{
  paydata: Paydata[],
  user_email: string;
  user_name?: string;
  user_phone?: string;
  partner_data?: string;
  order_id?: string;
}

export class InvoicesService {
  public static getInvoices(
    offset: number,
    limit: number,
    begin: string,
    end: string,
    status?: string,
    search?: string
  ): CancelablePromise<PaginatedResponseDTO<PaymentDTO>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/invoices',
      query: {
        offset,
        limit,
        begin,
        end,
        status,
        search
      },
    });
  }

  public static createInvoice(
    props: createInvoiceProps
  ): CancelablePromise<ResponseDTO<{link: string}>> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/invoices',
      body: {
        ...props
      },
    });
  }
}
